// extracted by mini-css-extract-plugin
export default {"main":"index_main_0YbAI","content":"index_content_phGGj","jump_box":"index_jump_box_jj1m1","jump":"index_jump_RyJt-","loading":"index_loading_31EVc"};